export const CSS_KEY_BLOCKLIST_RAW: string[] = [
  'color', 'bordercolor', 'backgroundcolor', 'linecolor', 'targetarrowcolor', 'sourcearrowcolor',
  'textbordercolor', 'textbackgroundcolor', 'textoutlinecolor', 'shadowcolor',
  'width', 'height', 'borderwidth', 'textborderwidth', 'textbackgroundpadding', 'textmaxwidth',
  'edge-length', 'edgelength', 'shadowblur', 'shadowoffsetx', 'shadowoffsety', 'padding', 'margin', 'fontsize',
  'shape', 'backgroundimage', 'curvestyle', 'curve-style', 'textvalign', 'textalign', 'textwrap',
  'fontfamily', 'font', 'background-opacity', 'text-background-opacity', 'opacity', 'breadcrumb', 'classes', '__dest', '__startWidth', '__startHeight',
];

export const AVAILABLE_LAYOUTS = [
  'breadthfirst',
  'cise',
  'cola',
  'cose',
  'cose-bilkent',
  'dagre',
  'euler',
  'fcose',
  'klay',
] as const;
